<app-badge customToolTip
           [contentTemplate]="tooltip"
           [showToolTip]="(numberOfMetric$ | async) > 0"
           *ngIf="enable$ | async">
  <app-source [item]="metric$ | async"
              [enableTooltip]="false"></app-source>
  <ng-container *ngIf="numberOfMetric$ | async">
    <span class="text-info">{{ 'reports.and_metrics' | translate: { nbMetrics: numberOfMetric$ | async } }}</span> <mat-icon class="material-icons-outlined info-icon">info</mat-icon>
  </ng-container>
</app-badge>
<ng-template #tooltip>
  <div class="display-flex flex-column row-gap-0-5rem">
    <app-source [item]="metric.payload"
                [enableCategory]="true"
                *ngFor="let metric of metrics$ | async"></app-source>
  </div>
</ng-template>
